import React, { useRef } from "react";
import { useNavigate } from "react-router-dom";
import MenuForm from "./MenuForm";
import api from "../../../utils/api";
import { toast } from "react-toastify";
import { useSubcategories } from "../../../hooks/useSubcategories";
import { showToast } from "../../../helper/generalHelper";

const SimpleMenuForm = ({ inventory }) => {
  const { subcategories, refetchSubcategories } = useSubcategories();
  const menuRef = useRef(null);
  const navigate = useNavigate();

  const handleSubmit = async () => {
    const sanitizedMenu = menuRef.current?.getSanitizedData();

    if (!sanitizedMenu) {
      toast.error("Please fill in all required fields.");
      return;
    }

    if (!sanitizedMenu.categoryId) {
      toast.error("Please select a Category.");
      return;
    }

    if (!sanitizedMenu.translations?.en?.title?.trim()) {
      toast.error("Please enter the Item Name.");
      return;
    }

    const payload = { menus: [sanitizedMenu], uploads: [] };

    try {
      const res = await api.post("restaurant/restaurant/menu/new", payload);
      showToast(res);
      if (res.success) {
        toast.success("Menu added successfully!");
        const isStaff = window.location.pathname.includes("/restaurant-staff");
        navigate(isStaff ? "/restaurant-staff/employee/menu/items" : "/restaurant/menus/all");
      }
    } catch (err) {
      console.error(err);
      toast.error("Submission failed.");
    }
  };

  return (
    <div className="max-w-6xl mx-auto bg-white shadow-lg rounded-2xl p-8 mt-10">
      <h2 className="text-2xl font-semibold text-gray-800 mb-6 border-b pb-3">
        Add New Menu Item
      </h2>

      <MenuForm ref={menuRef} categories={subcategories} inventory={inventory} onCategoryAdded={refetchSubcategories} />

      <div className="flex justify-end mt-6">
        <button
          onClick={handleSubmit}
          className="bg-blue-600 hover:bg-blue-700 text-white font-semibold px-6 py-2.5 rounded-lg shadow-md transition-all duration-150"
        >
          Submit
        </button>
      </div>
    </div>
  );
};

export default SimpleMenuForm;
